import { Result, Spin, Tabs } from 'antd';
import { format } from 'date-fns';
import { Component } from 'react';

import noImage from '../../assets/img/no-image.svg';
import FilmItem from '../FilmItem/FilmItem';
import PagePagination from '../Pagination/PagePagination';
import Search from '../Search/Search';

import './MovieMenu.scss';

class MovieMenu extends Component {
	render() {
		const {
			movies,
			ratedMovies,
			onSearchChange,
			loader,
			currentPage,
			totalItems,
			onPageChange,
			searchQuery,
			onTabChange,
			currentRatedPage,
			totalRatedItems,
			onRatePageChange,
			mobile,
		} = this.props;

		const renderMovies = (movies) => {
			if (movies && movies.length) {
				const movieData = movies.map((el) => {
					const date = el.release_date ? format(Date.parse(el.release_date), "MMMM d',' y") : 'No date release';
					const text = `${el.overview.split(' ', 15).join(' ')} ...`;
					const img = el.backdrop_path ? `http://image.tmdb.org/t/p/w500${el.backdrop_path}` : noImage;
					const ratingValue = localStorage.getItem(el.id) ? Number(localStorage.getItem(el.id)) : 0;
					return (
						<FilmItem
							key={el.id}
							id={el.id}
							img={img}
							title={el.title}
							date={date}
							text={text}
							ratingValue={ratingValue}
							genre={el.genre_ids}
							mobile={mobile}
							loader={loader}
						/>
					);
				});
				return movieData;
			} else if (!movies && !loader) {
				return <Result title="There are no movies for your request" />;
			}
		};

		const { TabPane } = Tabs;

		return (
			<>
				<div className="main__movie">
					<Tabs defaultActiveKey="1" centered onChange={onTabChange}>
						<TabPane tab="Search" key="1">
							<Search onSearchChange={onSearchChange} />
							<Spin spinning={loader} size="large" tip="Loading..." wrapperClassName="main__movie-wrapper">
								{renderMovies(movies)}
							</Spin>
							<PagePagination
								currentPage={currentPage}
								totalItems={totalItems}
								onPageChange={onPageChange}
								searchQuery={searchQuery}
								mobile={mobile}
							/>
						</TabPane>
						<TabPane tab="Rated" key="2">
							<Spin spinning={loader} size="large" tip="Loading..." wrapperClassName="main__movie-wrapper">
								{renderMovies(ratedMovies)}
							</Spin>
							<PagePagination currentPage={currentRatedPage} totalItems={totalRatedItems} onPageChange={onRatePageChange} mobile={mobile} />
						</TabPane>
					</Tabs>
				</div>
			</>
		);
	}
}

export default MovieMenu;
